.bam-compliance {
    font-family: var(--font-family);
}
